module.exports = __webpack_public_path__ + "static/media/Ubuntu-01.bf542b00.svg";